import { useUnit } from 'effector-react';
import { Col, Modal, Row, Table } from 'antd';
import { Bar, Column } from '@ant-design/charts';
import {
  $okedsData,
  $okedsModal,
  $okedsModalsFilters,
  changeOkedsModalsFiltersEv,
  changeSubOkedsModalEv,
  OkedsModalGate,
  resetOkedsModalEv,
} from '../../models/investProjectsModel/index.js';

function InvestOkedsModal() {
  const okedsModal = useUnit($okedsModal);
  const resetOkedsModal = useUnit(resetOkedsModalEv);
  const changeSubOkedsModal = useUnit(changeSubOkedsModalEv);
  const okedsData = useUnit($okedsData);

  const modalFilters = useUnit($okedsModalsFilters);
  const setModalFilters = useUnit(changeOkedsModalsFiltersEv);

  const regionsKPIColumns = [
    {
      title: '№',
      key: 'regions_num',
      dataIndex: 'num',
    },
    {
      title: 'Регион',
      key: 'regions_region',
      dataIndex: 'region',
    },
    {
      title: 'KPI-1',
      key: 'regions_kpi_1',
      dataIndex: 'kpi_1',
    },
    {
      title: 'KPI-2',
      key: 'regions_kpi_2',
      dataIndex: 'kpi_2',
    },
  ];

  const quarterKPIConfig = {
    data: okedsData?.quarter_kpi || [],
    isGroup: true,
    xField: 'quarter',
    yField: 'value',
    seriesField: 'type',
    label: {
      position: 'middle',
      layout: [
        {
          type: 'interval-adjust-position',
        },
        {
          type: 'interval-hide-overlap',
        },
        {
          type: 'adjust-color',
        },
      ],
    },
  };
  const regionBarConfig = {
    data: okedsData?.projects_by_region || [],
    isStack: true,
    xField: 'value',
    yField: 'region',
    seriesField: 'phase',
    label: {
      position: 'middle',
      layout: [
        {
          type: 'interval-adjust-position',
        },
        {
          type: 'interval-hide-overlap',
        },
        {
          type: 'adjust-color',
        },
      ],
    },
  };

  return (
    <Modal
      zIndex={102}
      open={!!okedsModal}
      onCancel={(e) => {
        e.stopPropagation();
        setModalFilters({ activity_id: null });
        resetOkedsModal();
      }}
      footer={null}
      width="80vw"
      destroyOnClose
    >
      <OkedsModalGate />
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Table
            pagination={false}
            columns={regionsKPIColumns}
            rowClassName={'pointer'}
            rowSelection={{
              hideSelectAll: true,
              selections: true,
              selectedRowKeys: modalFilters.region_id
                ? [modalFilters.region_id]
                : [],
              onChange: (keys) => {
                setModalFilters({
                  region_id: keys?.length > 0 ? keys?.at(-1) : null,
                });
              },
            }}
            rowKey={'id'}
            onRow={(record) => {
              return {
                onClick: (e) => {
                  setModalFilters({
                    region_id: record.id,
                  });
                  changeSubOkedsModal(record);
                },
              };
            }}
            dataSource={okedsData?.regions_kpi || []}
          />
        </Col>
        <Col span={16}>
          <Column {...quarterKPIConfig} />
        </Col>
        <Col span={24}>
          <Bar
            {...regionBarConfig}
            color={['rgb(249,228,91)', 'rgb(110, 147, 243)', 'rgb(148,255,92)']}
          />
        </Col>
      </Row>
    </Modal>
  );
}

export default InvestOkedsModal;
